import { useDispatch, useSelector } from 'react-redux';

import {
  Offices,
  CreateOffices,
  DeleteOffices,
  UpdateOffices,
  GetOfficesById,
} from '../../../store/actions';

/**
 * AccountsInjection is responsible for injecting the data into the Accounts page.
 *
 * @return
 *  getAccounts: () => Void
 * 	removeAccounts: () => Void
 * 	updateAccounts: () => Void
 *  deleteAccounts: () => void
 *  loadingAccount: boolean
 *  errorAccount: string
 *  accounts: object
 */
export const OfficesInjection = () => {
  /* constants */
  const dispatch = useDispatch();

  /**
   * @connectors
   *
   * these methods are responsible for accessing the store and dispatch the actions.
   * these guarantee that the module will be connected independent of methods used.
   * but you should always follow the rules of the methods.
   */

  /**
   * @return Void
   */
  const getOffices = async () => {
    dispatch(Offices());
  };

  /**
   * @return Void
   */
  const deleteOffices = async (id) => {
    dispatch(DeleteOffices(id));
  };

  /**
   * @return void
   */
  const createOffices = async (data) => {
    dispatch(CreateOffices(data));
  };

  /**
   * @return void
   */
  const updateOffices = async (id, data) => {
    dispatch(UpdateOffices(id, data));
  };

  /**
   * @return void
   */
  const getOfficesById = async (id) => {
    dispatch(GetOfficesById(id));
  };

  /**
   * @variables
   *
   * error: string
   * loading: boolean
   * user: object
   */
  const { offices, success, error } = useSelector((state) => ({
    error: state.Offices.error,
    offices: state.Offices.offices,
    success: state.Offices.success,
  }));

  return {
    error,
    offices,
    success,
    getOffices,
    getOfficesById,
    createOffices,
    deleteOffices,
    updateOffices,
  };
};
